import React from 'react';
import PropTypes from 'prop-types';

import './Logs.css';
class Logs extends React.PureComponent {
	state = {
		activeFilter: 'all'
	};

	render() {
		const { logs, clickLogsClear } = this.props;
		const { activeFilter } = this.state;

		const filteredLogs = logs.filter((logsObj) => {
			if (activeFilter === 'all') return true;
			return logsObj.type === activeFilter;
		});

		return (
			<div className="logs-wrapper">
				<div className="premium-header">
					<div className="analytics-title">
						<i className="material-icons" style={{ color: '#3498db' }}>text_snippet</i>
						<span>SYSTEM LOGS</span>
					</div>
					<button
						className="clear-logs-btn"
						onClick={clickLogsClear}
						disabled={filteredLogs.length === 0}
					>
						<i className="material-icons">delete_sweep</i>
						<span>CLEAR</span>
					</button>
				</div>

				<div className="logs-body scrollbar-hidden">
					{filteredLogs.length > 0 ? (
						<ul className="logs-list">
							{filteredLogs.map(({ time, message }, i) => (
								<li key={i} className="log-item">
									<span className="log-time">{time}</span>
									<span className="log-message">{message}</span>
								</li>
							))}
						</ul>
					) : (
						<div className="empty-logs">
							<i className="material-icons">article</i>
							<span>No logs available</span>
						</div>
					)}
				</div>
			</div>
		);
	}
}

Logs.propTypes = {
	logs: PropTypes.array.isRequired,
	clickLogsClear: PropTypes.func.isRequired,
	isPrimaryBroadcasting: PropTypes.bool
};

export default Logs;
